import { render } from "./SpotRegistrationListView.vue?vue&type=template&id=d7a65572"
import script from "./SpotRegistrationListView.vue?vue&type=script&lang=js"
export * from "./SpotRegistrationListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__